import { useAppDispatch, useAppSelector } from '@/Hook/hooks';
import { getScreenConfig } from '@/Redux/Ducks/entryFormSlice';
import { ControlTranslation } from 'AlignComponents';
import classNames from 'classnames';
import React from 'react'
import ModuleIcon from '../Aside/ModuleIcon';

const EntryFormWrapper = (props: any) => {
  const dispatch = useAppDispatch();

  const { isConfigLoaded, settingObjects, isSetting, moduleno, modulestxt, processcode } = useAppSelector((state) => {
    let activeObject = state.EntryForm.activeObjectId;
    let object = state.EntryForm.objects[activeObject];
    let moduleno: string = object?.ScreenConfig?.TcodeConfiguration?.moduleno || "";
    let modulestxt: string = object?.ScreenConfig?.TcodeConfiguration?.modulestxt || "";
    let processcode: string = object?.ScreenConfig.TcodeConfiguration.processcode || "";

    return {
      isConfigLoaded: state.EntryForm.isConfigLoaded,
      settingObjects: state.Home.userObjects.filter(x => x.moduleno == moduleno && x.issetting),
      isSetting: state.Home.userObjects.find(x => x.objectcontrollerno == processcode)?.issetting,
      moduleno,
      modulestxt,
      processcode
    }
  });


  const clickHandler = (processCode: string) => {
    dispatch(getScreenConfig({ processCode }));
  }

  return (
    <div className={classNames([{ setting: isSetting }])}>
      {
        isSetting ? (
          <div className="setting-menu">
            <div className="setting-title">
              <div className="icon">
                <ModuleIcon moduleno={moduleno} />
              </div>
              <h6>
                {modulestxt} <ControlTranslation system={true} controlId="lblsetting" />
              </h6>
            </div>

            <div className="setting-navs">
              {
                isSetting && settingObjects
                  .map((x: any) => (
                    <div key={`setting-` + x.moduleno + `-` + x.objectcontrollerno} className={classNames(["setting-nav", { active: x.objectcontrollerno == processcode }])} onClick={() => clickHandler(x.objectcontrollerno)}>
                      {x.objectcontrollerstxt}
                    </div>
                  ))
              }
            </div>
          </div>
        )
          : null
      }

      {props.children}
    </div>
  )
}

export default EntryFormWrapper